module.exports = __webpack_public_path__ + "static/media/city-clinic-elements-svgrepo-com.cbf918a8.svg";